import React from "react";
import Button from "../../../../../../components/ui/Button";
import {DrawingType, Status} from "../../../../../../models/enums";
import {useTranslation} from "react-i18next";
import {useParams} from "react-router-dom";
import {useSelector} from "react-redux";
import ConfigHelper from "../config/ConfigHelper";
import useCreateAsBuiltFromTakeoff from "../../../../../project-details/hooks/useCreateAsBuiltFromTakeoff";
import {useDrawingDetailsDataContext} from "../../../../providers/DrawingDetailsProvider";
import {useProjectDetailContext} from "../../../../../project-details/providers/ProjectDetailProvider";
import {INITIAL_VERSION_ID} from "../../constants";
import {selectScaleConfig} from "../scale/scaleSlice";
import {selectEditorIsDirty} from "../view/viewSlice";
import Tooltip from "../../../../../../components/tooltip/Tooltip";
import {selectActiveTool} from "../config/configSlice";
import {EditorTool} from "../../models/enums";
import {selectIsDrawingWallSegment} from "../topViewWallArea/topViewWallAreaSlice";

interface CreateAsBuiltProps {
	disabled: boolean;
}

const CreateAsBuilt: React.FC<CreateAsBuiltProps> = ({disabled}) => {
	const {t} = useTranslation();
	const {
		projectId,
		drawingId,
		versionId,
		costCenterId,
		sectionId
	} = useParams<{ projectId: string, sectionId: string, costCenterId: string, drawingId: string, versionId: string }>();
	const scaleConfig = useSelector(selectScaleConfig);
	const activeTool = useSelector(selectActiveTool);
	const isDrawingWallSegment = useSelector(selectIsDrawingWallSegment);
	const {isJobProject, forceTreeUpdate} = useProjectDetailContext()
	const {drawingData: {loadStatus: drawingDetailsLoadStatus, drawingDetails}} = useDrawingDetailsDataContext();
	const {createAsBuilt, saveStatus} = useCreateAsBuiltFromTakeoff(
		projectId, sectionId, costCenterId, drawingId, versionId, drawingDetails?.name ?? "As Built"
	);
    const isDirty = useSelector(selectEditorIsDirty)

    function handleClick() {
		createAsBuilt(forceTreeUpdate)
	}

	if (activeTool === EditorTool.TOP_VIEW_WALL_AREA && isDrawingWallSegment) {
		return null;
	}

	return isJobProject && drawingDetails?.drawingType === DrawingType.TAKE_OFF ? (
            <Tooltip tooltipText={isDirty? t("projects.details.createNewDrawingModal.saveToEnable.create_as_built") : ""}>
                <Button label={t("projects.details.planTemplates.createAsBuiltButton")}
                        onClick={handleClick}
                        variant={"optional"}
                        disabled={!ConfigHelper.isScaleSet(scaleConfig)
                            || isDirty
                            || saveStatus === Status.LOADING
                            || disabled
                            || versionId === INITIAL_VERSION_ID
                            || drawingDetailsLoadStatus !== Status.SUCCESS}/>
            </Tooltip>
	) : null;
};

export default CreateAsBuilt;
